/**
 * Portal Manta · KbCurated
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { V, S } from '../../globals.js';
import { THl, TH, TDl, TD } from '../../app-globals.js';

function KbCurated(){
  return(<div style={S.page}>
    <div style={S.h1}>📚 KB Curada · Análises e Composições</div>
    <div style={S.sub}>Insights consolidados sobre orçamento dos 3 lotes PR · benchmarks · drivers de custo</div>

    {/* CARD DE ANÁLISE: por que L5 é mais caro/km */}
    <div style={{...S.cardP,marginBottom:14,borderLeft:'4px solid '+V.or}}>
      <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
        <span style={{fontSize:13,fontWeight:700,color:V.br}}>🔍 Por que o Lote 5 é mais caro por km?</span>
        <span style={{...S.pillBase,background:V.or,color:'#fff'}}>R$ 1.655/km · 1,53× L3</span>
        <span style={{fontSize:9.5,color:V.gr,marginLeft:'auto'}}>Análise consolidada · {(()=>{const d=new Date();return d.toLocaleDateString('pt-BR');})()}</span>
      </div>
      <div style={{fontSize:11,color:V.br,lineHeight:1.65,marginBottom:14}}>
        L5 tem custo SICRO de <b>R$ 1.655/km</b>, contra <b>R$ 1.079/km</b> de L3 e <b>R$ 1.291/km</b> de L4. 
        A diferença NÃO é uniforme entre disciplinas — concentra-se em <b>3 drivers críticos</b>.
      </div>

      <div style={{fontSize:10.5,fontWeight:700,color:V.gr,marginBottom:6,letterSpacing:.4}}>DRIVERS QUANTITATIVOS (R$/km L5 vs L3)</div>
      <div style={{...S.card,overflow:'hidden',marginBottom:14}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
          <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
            <th style={THl}>Disciplina</th>
            <th style={TH}>L3 R$/km</th>
            <th style={TH}>L4 R$/km</th>
            <th style={TH}>L5 R$/km</th>
            <th style={TH}>L5/L3</th>
            <th style={THl}>Causa provável</th>
          </tr></thead>
          <tbody>
            <tr style={{...S.trLine,background:'#fef2f2'}}>
              <td style={TDl}>OAEs</td>
              <td style={TD}>R$ 19</td><td style={TD}>R$ 3</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>R$ 157</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>8,39×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>Ponte Ayrton Senna (PR/MS na BR-163), viadutos em Cascavel + Maringá. OAEs maiores/mais complexas apesar da menor densidade.</td>
            </tr>
            <tr style={{...S.trLine,background:'#fef9c3'}}>
              <td style={TDl}>Drenagem</td>
              <td style={TD}>R$ 211</td><td style={TD}>R$ 79</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>R$ 458</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>2,17×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>Oeste do PR mais hidrológico (cursos d'água), travessias urbanas (Cascavel) com drenagem urbana intensa.</td>
            </tr>
            <tr style={{...S.trLine,background:'#dbeafe'}}>
              <td style={TDl}>Iluminação</td>
              <td style={TD}>R$ 5</td><td style={TD}>R$ 0</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>R$ 80</td>
              <td style={{...TD,fontWeight:700,color:V.or}}>17,72×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>L5 atravessa Cascavel + Campo Mourão + Maringá (cidades médias importantes). L3/L4 quase sem iluminação contratada.</td>
            </tr>
            <tr style={S.trLine}>
              <td style={TDl}>Pavimentação</td>
              <td style={TD}>R$ 462</td><td style={TD}>R$ 782</td><td style={TD}>R$ 523</td>
              <td style={TD}>1,13×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>Variação pequena. L4 tem mais por causa de mais faixas adicionais.</td>
            </tr>
            <tr style={S.trLine}>
              <td style={TDl}>Terraplenagem</td>
              <td style={TD}>R$ 222</td><td style={TD}>R$ 308</td><td style={TD}>R$ 247</td>
              <td style={TD}>1,11×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>Quase idênticos. Não é driver.</td>
            </tr>
            <tr style={S.trLine}>
              <td style={TDl}>Sinalização</td>
              <td style={TD}>R$ 96</td><td style={TD}>R$ 55</td><td style={TD}>R$ 126</td>
              <td style={TD}>1,32×</td>
              <td style={{...TDl,fontSize:9.5,color:V.gr}}>Pequena diferença, alinhada com mais conurbação.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{fontSize:10.5,fontWeight:700,color:V.gr,marginBottom:6,letterSpacing:.4}}>DRIVERS QUALITATIVOS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',gap:10,marginBottom:12}}>
        <div style={{...S.cardP,borderTop:'3px solid '+V.or}}>
          <div style={{fontSize:10,fontWeight:700,color:V.or,letterSpacing:.3}}>1 · CONTEXTO URBANO</div>
          <div style={{fontSize:11,color:V.br,marginTop:6,lineHeight:1.5}}>L5 atravessa <b>Cascavel</b>, <b>Campo Mourão</b> e <b>Maringá</b> — 3 cidades médias importantes. Resulta em alta densidade de iluminação, drenagem urbana, passarelas e marginais.</div>
        </div>
        <div style={{...S.cardP,borderTop:'3px solid '+V.or}}>
          <div style={{fontSize:10,fontWeight:700,color:V.or,letterSpacing:.3}}>2 · TRAVESSIAS GRANDES</div>
          <div style={{fontSize:11,color:V.br,marginTop:6,lineHeight:1.5}}>Apesar de ter MENOS OAEs/km que L3 (0,15 vs 0,34), as OAEs do L5 são <b>maiores e mais complexas</b> — incluindo a travessia da Ponte Ayrton Senna na divisa PR/MS (BR-163).</div>
        </div>
        <div style={{...S.cardP,borderTop:'3px solid '+V.or}}>
          <div style={{fontSize:10,fontWeight:700,color:V.or,letterSpacing:.3}}>3 · MAIS DUPLICAÇÃO RELATIVA</div>
          <div style={{fontSize:11,color:V.br,marginTop:6,lineHeight:1.5}}>L5 tem <b>54,8% do trecho</b> com duplicação/contornos vs 40-42% em L3/L4. Maior intensidade de obra pesada por km.</div>
        </div>
        <div style={{...S.cardP,borderTop:'3px solid '+V.bl}}>
          <div style={{fontSize:10,fontWeight:700,color:V.bl,letterSpacing:.3}}>4 · GRANULARIDADE SICRO</div>
          <div style={{fontSize:11,color:V.br,marginTop:6,lineHeight:1.5}}>L5 tem <b>364 itens SICRO</b> detalhados (vs 99 em L3 e 99 em L4). Pode indicar orçamento mais maduro/realista, com menos itens consolidados em verbas.</div>
        </div>
      </div>

      <div style={{...S.cardP,marginTop:6,padding:'10px 14px',background:'#fef3c7',borderLeft:'4px solid '+V.am||'#d97706'}}>
        <div style={{fontSize:10,fontWeight:700,color:V.am||'#d97706',letterSpacing:.4,marginBottom:4}}>⚠ ALERTA — POSSÍVEL SUB-ORÇAMENTAÇÃO EM L4</div>
        <div style={{fontSize:11,color:V.br,lineHeight:1.6}}>
          O Lote 4 mostra valores anormalmente baixos em <b>OAEs (R$ 3/km)</b> e <b>Iluminação (R$ 0/km)</b>. 
          Considerando que o L4 atravessa Londrina, Maringá e Arapongas, esperaria-se valores próximos aos do L5. 
          <b>Hipótese:</b> esses itens podem estar contabilizados em outra rubrica do MEF (não no SICRO consolidado), ou faltam itens no detalhamento. 
          <b>Recomendação:</b> conferir a fonte do CONSOL_FIN para L4 contra o MEF Vol II e os 5 Tomos de Engenharia.
        </div>
      </div>

      <div style={{...S.cardP,marginTop:8,fontSize:10,color:V.gr,lineHeight:1.6}}>
        <b>Síntese:</b> a diferença de R$ 576/km (L5−L3) é <b>57% explicada</b> por 3 disciplinas — OAEs (+R$ 138/km), Drenagem (+R$ 247/km), Iluminação (+R$ 75/km). 
        As demais disciplinas (Pavimentação, Terraplenagem, Sinalização, Serv.Preliminares) têm variação menor que 1,4× e não são drivers significativos.
        <br/><b>Implicação para novos orçamentos:</b> o contexto urbano e a presença de travessias estruturais grandes são os fatores mais sensíveis. 
        Para uma concessão similar, as três rubricas acima precisam de atenção especial — com benchmarks claros do tipo de obra esperada.
      </div>
    </div>

    {/* Outros cards curados que existiam antes */}
    <div style={S.h2}>Outras análises curadas</div>
    <div style={{...S.cardP,fontSize:11,color:V.gr,fontStyle:'italic'}}>
      Esta KB curada serve como repositório de análises consolidadas pela Manta sobre os 3 lotes PR. 
      Para adicionar novas análises (composições típicas, BDI por tipo de obra, comparativo de fornecedores), use o backend (POST /api/kb com tipo="estudo" ou "composicao").
    </div>

  </div>);
}

export { KbCurated };
export default KbCurated;
